import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { CalendarIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

import { CALENDAR_PROVIDERS, getCalendarLink } from './providerUrls';
import ProviderIcon from './providerIcons';

const AddToCalendarButton = ({ calendar, label, preview = false }) => {
  if (!calendar?.event) return null;

  // Preview lists every provider even though it has no signed ics url, so the
  // merchant can see what buyers will be offered. The options are inert there,
  // so a missing link cannot be followed.
  const providers = CALENDAR_PROVIDERS.map(provider => ({
    ...provider,
    href: getCalendarLink(provider.id, calendar),
  })).filter(provider => preview || provider.href);

  if (!providers.length) return null;

  return (
    <div className="cp_add-to-calendar mt-4 flex justify-center">
      <Menu as="div" className="cp_add-to-calendar-menu relative inline-block text-left">
        {/* The submit button's own pair, because CheckoutCSS derives its text
            colour for contrast against that background and always emits a
            concrete value. The raw theme colour defaults to a Tailwind token
            that can go unresolved, leaving the label the same shade as the
            button it sits on. */}
        <MenuButton className="cp_add-to-calendar-button inline-flex items-center gap-x-2 rounded-[var(--cp_checkout-form-button-border-radius)] px-4 py-2 text-[var(--cp_submit-button-text-color)] [background-color:var(--cp_submit-button-background-color)]">
          <CalendarIcon className="cp_add-to-calendar-icon h-5 w-5" />
          {label}
          <ChevronDownIcon className="cp_add-to-calendar-chevron h-4 w-4" />
        </MenuButton>

        {/* anchor renders the list in a portal. The confirmation card clips its
            overflow, which cut an in-card menu off at the card edge. The portal
            sits outside .cp_page, so the body font is restated. */}
        <MenuItems
          anchor={{ to: 'bottom', gap: 8 }}
          className="cp_add-to-calendar-items z-50 w-48 rounded-md bg-white py-1 text-left shadow-lg ring-1 ring-black/5 [font-family:var(--cp_font-body)] focus:outline-none"
        >
          {providers.map(provider => (
            <MenuItem key={provider.id} disabled={preview}>
              <a
                href={preview ? undefined : provider.href}
                target={preview ? undefined : '_blank'}
                rel="nofollow noopener noreferrer"
                aria-disabled={preview || undefined}
                className={`cp_add-to-calendar-item flex items-center gap-x-2 px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 ${
                  preview ? 'cursor-not-allowed opacity-60' : ''
                }`}
              >
                <ProviderIcon
                  providerId={provider.id}
                  className="cp_add-to-calendar-item-icon h-4 w-4 shrink-0"
                />
                {provider.name}
              </a>
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>
    </div>
  );
};

export default AddToCalendarButton;
